import { useEffect, useState } from "react";
import {
  Box,
  Text,
  Heading,
  Flex,
  Container,
  Button,
  SimpleGrid,
  HStack,
  Icon,
  Link,
  Badge,
  Grid,
  List,
  ListItem,
  ListIcon,
  GridItem,
} from "@chakra-ui/react";

import { FiGlobe, FiZap, FiClock, FiShield } from "react-icons/fi";

import { CheckIcon } from "@chakra-ui/icons";
import { linksConfig } from "../../utils/CommonLinks";
import GrpcDediStyles from "../gRPCPage/grpc-dedi-css.module.css";

const configurations = [
  { cpu: "AMD 9254", memory: "384 GB", price: "$1800/month", alternate: false },
  { cpu: "AMD 7543", memory: "1 TB", price: "$2000/month", alternate: true },
  { cpu: "AMD 9354", memory: "512 GB", price: "$2200/month", alternate: false },
  { cpu: "AMD 9354", memory: "768 GB", price: "$2500/month", alternate: true },
  { cpu: "AMD 9354", memory: "1 TB", price: "$2800/month", alternate: false },
];

const DedicatedNodes = (props) => {
  const bgColor = "#101010";
  const cardBg = "#181818";
  const tabBg = "#181818";
  const activeTabBg = "#E33535";
  const primaryColor = "#E33535";
  const secondaryColor = "#FBB901";
  const borderColor = "#333333";
  const textColor = "#FFFFFF";
  const textMuted = "rgba(255, 255, 255, 0.7)";
  const textLight = "rgba(255, 255, 255, 0.5)";
  useEffect(() => {
    setTimeout(() => {
      props.setLoading(false);
    }, 800);
    // if (data !== null || errOcc === true) props.setLoading(false);
  }, []);
  return (
    <div>
      <Container maxW={"8xl"}>
        <Box as="div" py={{ base: "16px", md: "24px" }} borderRadius={"14px"}>
          <Box>
            <Text
              as={"div"}
              fontFamily={"heading"}
              color={"brand.white"}
              fontSize={"2xl"}
              lineHeight={"3xl"}
              fontWeight={"600"}
              position={"relative"}
            >
              Shyft gRPC Nodes - Engineered for Resilience & Speed
            </Text>

            <Text
              as={"div"}
              fontSize={{ base: "14px", lg: "md" }}
              fontWeight={"400"}
              color={"brand.lighterWhite"}
              pt={{ base: "4px", md: "6px" }}
            >
              Purpose-built for peak uptime and blazing-fast throughput — shred-accelerated nodes with resilient DNS and load balancing at their core.
            </Text>
          </Box>

          <Box as="section" className={GrpcDediStyles.features}>
            <Box
              as="div"
              borderRadius="2xl"
              py={12}
              px={{ base: 8, md: 8 }}
              border={"2px solid"}
              borderColor="brand.faintGrey"
              mt={14}
              bg={"#000"}
            >
              {/* <Heading as="h3" size="md" mb={6}>
                        Enterprise-grade Dedicated Nodes
                      </Heading> */}
              <SimpleGrid
                columns={{ base: 1, lg: 2 }}
                spacingX="24"
                spacingY="8"
                justifyContent={"space-evenly"}
              >

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiShield} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Zero Downtime
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Built-in fault tolerance across DNS and load balancing ensures seamless uptime — 
                      with automatic failovers to backup pools, your systems stay resilient.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiGlobe} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Worldwide Availability
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Our dedicated nodes are available in multiple locations
                      across Europe, the United States and South-east Asia.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiZap} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Powered by Shredstreams
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Experience lightning-fast streaming with updates directly
                      from Solana leaders. Get upto 50ms advantage over shared
                      gRPC by connecting directly to your node.
                    </Text>
                  </Box>
                </HStack>

                

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiClock} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Priority Support
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Top priority with direct communication channels with Shyft
                      devs. Focus on the product, we have your back.
                    </Text>
                  </Box>
                </HStack>
              </SimpleGrid>
              <Box pt={8}>
                <Flex justifyContent={"center"}>
                  <Box>
                    <Link
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      _hover={{ textDecoration: "none" }}
                    >
                      <Box
                        width={{ base: "160px", md: "160px" }}
                        bg={"brand.red"}
                        color={"brand.white"}
                        rounded={"full"}
                        height={{ base: "40px", md: "40px" }}
                        py={{ base: "6px", md: "7px" }}
                        _hover={{
                          bg: "brand.white",
                          color: "brand.red",
                        }}
                        style={{
                          transition: "all 0.2s ease",
                        }}
                        textAlign={"center"}
                        fontFamily={"heading"}
                        fontWeight={500}
                        fontSize={{ base: "sm", md: "md" }}
                      >
                        Connect with us
                      </Box>
                    </Link>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </Box>

          

          <Box
            borderRadius="xl"
            border="1px solid"
            borderColor={"brand.faintGrey"}
            overflow="hidden"
            boxShadow="lg"
            bg={"#000"}
            mt={-12}
          >
            <Flex
              direction={{ base: "row", md: "row" }}
              borderBottom="1px solid"
              borderColor={borderColor}
            >
              <Box flex="1" p={{ base: 6, md: 8 }}>
                <Badge
                  bg="rgba(251, 185, 1, 0.2)"
                  color={secondaryColor}
                  px={3}
                  py={1}
                  borderRadius="sm"
                  fontSize={{ base: "2xs", md: "sm" }}
                  mb={2}
                >
                  ENTERPRISE GRADE
                </Badge>
                <Heading as="h3" fontSize={{ base: "2xl", md: "3xl" }} mb={2} color={"brand.white"}>
                  Dedicated gRPC Nodes
                </Heading>
                <Text color={textMuted} fontSize={{ base: "sm", md: "md" }}>
                  Exclusive high-performance nodes with Shred acceleration and
                  intelligent load balancers.
                </Text>
              </Box>
              <Flex
                direction="column"
                align={{ base: "start", md: "flex-end" }}
                justifyContent={{ base: "center", md: "center" }}
                px={{ base: 6, md: 8 }}
                pt={{ base: 0, md: 8 }}
                borderLeft={"1px solid"}
                borderColor={"brand.faintGrey"}
                textAlign={"right"}
                // borderTop={{ base: "1px solid", md: "none" }}
              >
                <Text
                  color={"brand.midGrey"}
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  Starting from
                </Text>
                <Heading
                  as="h4"
                  fontSize={{ base: "3xl", md: "4xl" }}
                  lineHeight={0.4}
                  color={"brand.white"}
                >
                  $1800
                </Heading>
                <Text
                  fontSize={{ base: "xs", md: "sm" }}
                  color={"brand.midGrey"}
                  lineHeight={{ base: "2rem", md: "2.2rem" }}
                >
                  per month
                </Text>
              </Flex>
            </Flex>

            <Box p={{ base: 6, md: 8 }}>
              <Grid templateColumns={{ base: "1fr", md: "6fr 7fr" }} gap={8}>
                <Box>
                  <Box>
                    <HStack align="center" mb={4}>
                      <FiZap color={primaryColor} boxSize={8} />
                      <Heading as="h5" fontSize="xl" fontWeight="500" mt={1} color={"brand.white"}>
                        Key Features
                      </Heading>
                    </HStack>
                    <List spacing={3}>
                      <ListItem fontSize="sm" color={textMuted}>
                        <ListIcon as={CheckIcon} color={primaryColor} />
                        Get direct access to the node without any load balancer.
                      </ListItem>
                      <ListItem fontSize="sm" color={textMuted}>
                        <ListIcon as={CheckIcon} color={primaryColor} />
                        Outperforms the shared network.
                      </ListItem>
                      <ListItem fontSize="sm" color={textMuted}>
                        <ListIcon as={CheckIcon} color={primaryColor} />
                        Accelerated with Shredstreams.
                      </ListItem>
                      <ListItem fontSize="sm" color={textMuted}>
                        <ListIcon as={CheckIcon} color={primaryColor} />
                        Isolated from any traffic/impact from shared infra.
                      </ListItem>
                      <ListItem fontSize="sm" color={textMuted}>
                        <ListIcon as={CheckIcon} color={primaryColor} />
                        Priority support and direct communication with Shyft
                        devs.
                      </ListItem>
                    </List>
                  </Box>
                </Box>

                <Box>
                  <Box
                    border={"1px solid"}
                    borderColor={"brand.faintGrey"}
                    paddingX={4}
                    paddingY={4}
                    borderRadius={"10px"}
                  >
                    {/* Table Header */}
                    <Heading as="h5" fontSize="lg" fontWeight="500" color={"brand.white"}>
                      Available Configurations
                    </Heading>
                    <Box pt={2} fontSize={{ base: "xs", md: "md" }}>
                      <Grid
                        templateColumns="1fr 3fr 1fr"
                        bg={"brand.red"}
                        color={"brand.lighterWhite"}
                        fontWeight="600"
                        p={3}
                        borderTopRadius="md"
                      >
                        <GridItem>Config</GridItem>
                        <GridItem></GridItem>
                        <GridItem textAlign={"center"} pe={5}>
                          Price
                        </GridItem>
                      </Grid>

                      {/* Table Rows */}
                      {configurations.map((config, index) => (
                        <Grid
                          key={index}
                          templateColumns="1fr 1fr 1fr"
                          bg={config.alternate ? "#111" : "#000"}
                          p={3}
                          justifyContent={"space-between"}
                          borderBottom={`1px solid`}
                          borderColor={
                            index === configurations.length - 1
                              ? "brand.red"
                              : "transparent"
                          }
                          fontSize={{ base: "xs", md: "md" }}
                        >
                          <GridItem color={"brand.lighterWhite"}>
                            {config.cpu}/{config.memory}
                          </GridItem>
                          <GridItem></GridItem>

                          <GridItem
                            color={"brand.lighterWhite"}
                            textAlign={"end"}
                          >
                            {config.price}
                          </GridItem>
                        </Grid>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Flex
                mt={{ base: 8, md: 8 }}
                mb={2}
                direction={{ base: "column", md: "row" }}
                align={{ base: "center", md: "center" }}
                justify="center"
                gap={4}
              >
                <Button
                  as={"a"}
                  href={linksConfig.DISCORD_LINK}
                  bg={"brand.red"}
                  color="white"
                  size={{ base: "md", md: "lg" }}
                  fontWeight="400"
                  fontFamily={"heading"}
                  px={{ base: "20px", md: 8 }}
                  borderRadius={"full"}
                  _hover={{
                    bg: "brand.white",
                    color: "brand.red",
                  }}
                >
                  Connect with us
                </Button>
              </Flex>
            </Box>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default DedicatedNodes;
